import React from 'react';
import { useAppContext } from '../App';

const ApplicationsSection = ({ applications }) => {
  const { handleExploreApplication } = useAppContext();

  return (
    <div className="applications-grid">
      {applications.slice(0, 2).map((app, index) => (
        <div
          key={app.id}
          className="application-card"
          style={{ animationDelay: `${index * 0.1}s` }}
          onClick={() => handleExploreApplication(app)}
        >
          <div className="app-image">
            <img src={app.image} alt={app.name} />
            <div className="app-overlay">
              <span className="app-icon">{app.icon}</span>
            </div>
          </div>
          <div className="app-content">
            <h4 className="app-name">{app.name}</h4>
            <p className="app-description">{app.description}</p>
            <div className="app-footer">
              <span className="app-count">{app.productCount.toLocaleString()} products</span>
              <button className="explore-btn">
                Explore
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ApplicationsSection;
